export function generateSecurePassword() {
  const lowercase = 'abcdefghijkmnpqrstuvwxyz';
  const uppercase = lowercase.toUpperCase();
  const numbers = '23456789';
  const specials = '!@?#$%^&*()_+-=';
  const all = lowercase + uppercase + numbers + specials;
  const required = [
    randomCharacter(lowercase),
    randomCharacter(uppercase),
    randomCharacter(numbers),
    randomCharacter(specials),
  ];
  const remaining = Array.from({ length: 8 }, () => randomCharacter(all));
  return shuffle([...required, ...remaining]).join('');
}

function randomCharacter(characters: string) {
  const random = new Uint32Array(1);
  crypto.getRandomValues(random);
  return characters[(random[0] ?? 0) % characters.length] ?? characters[0] ?? '';
}

function shuffle(values: string[]) {
  const shuffled = [...values];
  for (let index = shuffled.length - 1; index > 0; index -= 1) {
    const random = new Uint32Array(1);
    crypto.getRandomValues(random);
    const swapIndex = (random[0] ?? 0) % (index + 1);
    [shuffled[index], shuffled[swapIndex]] = [shuffled[swapIndex] ?? '', shuffled[index] ?? ''];
  }
  return shuffled;
}
